
import { Vue, Component } from 'vue-property-decorator';
import BlogDetail from '@/components/blog/detail.vue';

@Component({
  name: 'SupportDetail',
  components: {
    BlogDetail,
  },
})
export default class extends Vue {
}
